import { FolderType, RecommendationItemFolder } from './folders';

export class AddRecommendationItemJsEnv {
  companyId: string;
  departmentId: string;
  folderShareType: FolderType;
  recommendationFolderName: string;
  companyRecommendationFolders: RecommendationItemFolder[];
  departmentRecommendationFolders: RecommendationItemFolder[];

  marginCount: number = 20;
  isLoadedCompanyFolders: boolean = false;
  isLoadedDepartmentFolders: boolean = false;
  isWarningHidden: boolean = true;
  isCreateFolderWarningHidden: boolean = true;
  warningMessage: string = '';

  supplierId: string;
  catalogItemCode: string;
  variationCode: string;

  // 推奨品フォルダ一覧参照API結果
  recommendationItemFoldersApiResult: RecommendationItemFoldersAPI = RecommendationItemFoldersAPI.OK;

  constructor(
    companyId: string,
    departmentId: string,
    folderShareType: FolderType,
    recommendationFolderName: string,
    marginCount: number,
    isLoadedCompanyFolders: boolean,
    isLoadedDepartmentFolders: boolean,
    isCreateFolderWarningHidden: boolean,
    isWarningHidden: boolean,
    companyRecommendationFolders: RecommendationItemFolder[],
    departmentRecommendationFolders: RecommendationItemFolder[],
    supplierId: string,
    catalogItemCode: string,
    variationCode: string
  ) {
    this.companyId = companyId;
    this.departmentId = departmentId;
    this.folderShareType = folderShareType;
    this.recommendationFolderName = recommendationFolderName;
    this.marginCount = marginCount;
    this.isLoadedCompanyFolders = isLoadedCompanyFolders;
    this.isLoadedDepartmentFolders = isLoadedDepartmentFolders;
    this.isWarningHidden = isWarningHidden;
    this.isCreateFolderWarningHidden = isCreateFolderWarningHidden;
    this.companyRecommendationFolders = companyRecommendationFolders;
    this.departmentRecommendationFolders = departmentRecommendationFolders;
    this.supplierId = supplierId;
    this.catalogItemCode = catalogItemCode;
    this.variationCode = variationCode;
  }
}

// 推奨品フォルダ一覧参照API結果
export const RecommendationItemFoldersAPI = {
  OK : 'OK',
  NO_FOLDERS : 'NO_FOLDERS',
  ERROR : 'ERROR',
} as const;
export type RecommendationItemFoldersAPI = typeof RecommendationItemFoldersAPI[keyof typeof RecommendationItemFoldersAPI]
